import { render, staticRenderFns } from "./new-question.vue?vue&type=template&id=7bced072&scoped=true&"
import script from "./new-question.vue?vue&type=script&lang=js&"
export * from "./new-question.vue?vue&type=script&lang=js&"
import style0 from "./new-question.vue?vue&type=style&index=0&id=7bced072&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bced072",
  null
  
)

export default component.exports